import { Typography } from "@mui/material";
import { Flex } from "Components/_Shared/Core/Flex";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";

const SIZE = "20px";

type Props = {
  readonly count: number;
  readonly isActive?: boolean;
};

export const CountBadge: React.FC<Props> = ({ count, isActive = false }) => {
  return (
    <Flex
      component="span"
      alignItems="center"
      justifyContent="center"
      minWidth={SIZE}
      height={SIZE}
      px={Spacing.XS}
      borderRadius={Radius.MAX}
      flexShrink={0}
      sx={(theme) => ({ backgroundColor: isActive ? theme.palette.primary.light : theme.colors.backgroundTertiary })}
    >
      <Typography
        component="span"
        variant="caption"
        color={isActive ? "primary.main" : "text.secondary"}
        fontWeight={600}
        lineHeight={1}
        letterSpacing={0}
      >
        {count}
      </Typography>
    </Flex>
  );
};
